'use strict';

/**
 * Collection of constants related with the select component.
 * @typedef DatepickerConstants
 * @property {Object} ATTRIBUTES HTML attribute constants.
 * @property {Object} ATTRIBUTES.DATA HTML data attribute constants.
 * @property {string} ATTRIBUTES.DATA.END_DATE HTML date picker end date data attribute constant.
 * @property {string} ATTRIBUTES.DATA.FORMAT HTML date picker format data attribute constant.
 * @property {string} ATTRIBUTES.DATA.ID HTML date picker identifier data attribute constant.
 * @property {string} ATTRIBUTES.DATA.IS_DATE_PICKER HTML date picker is date picker data attribute constant.
 * @property {string} ATTRIBUTES.DATA.IS_LOADED HTML date picker is date picker loaded data attribute constant.
 * @property {string} ATTRIBUTES.DATA.START_DATE HTML date picker start date data attribute constant.
 * @property {Object} CONFIG bootstrap date picker configuration properties.
 * @property {string} CONFIG.FORMAT bootstrap date picker date format configuration property.
 * @property {Object} CONFIG.MAX_VIEW_MODE bootstrap date picker max view mode configuration properties.
 * @property {number} CONFIG.MAX_VIEW_MODE.DAYS bootstrap date picker days max view mode configuration property.
 * @property {number} CONFIG.MAX_VIEW_MODE.MONTHS bootstrap date picker months max view mode configuration property.
 */

/**
 * Collection of datepicker related constants
 * @type {DatepickerConstants}
 */
var CONSTANTS = {};

/**
 * HTML attribute constants
 */
CONSTANTS.ATTRIBUTES = {
    DATA: {
        END_DATE: 'data-end-date',
        FORMAT: 'data-date-format',
        ID: 'data-date-id',
        IS_DATE_PICKER: 'data-is-datepicker',
        IS_LOADED: 'data-is-datepicker-loaded',
        START_DATE: 'data-start-date'
    }
};

/**
 * Bootstrap datepicker configuration constants
 */
CONSTANTS.CONFIG = {
    FORMAT: 'dd/mm/yyyy',
    MAX_VIEW_MODE: {
        DAYS: 0,
        MONTHS: 1
    }
};

module.exports = CONSTANTS;
